<template>
  <DataList
    title="Рахунки на сплату"
    resource="invoices"
    :columns="columns"
    :get-items-fn="getInvoices"
    search-label="Пошук за назвою клієнта, № рахунку"
    :filter="filter"
  >
    <template v-slot:filters>
      <v-row dense>
        <v-col cols="3">
          <EnumSelect
            v-model="rolePaymentState"
            :items="paymentStateTypes"
            label="Статус Оплати"
            placeholder="Виберіть статус оплати"
            clearable
          />
        </v-col>
        <v-col cols="2">
          <DatePicker
            v-model="dateFrom"
            placeholder="Дата з"
            label="Наявність оплат"
            :filled="false"
            clearable
          />
        </v-col>
        <v-col cols="2">
          <DatePicker
            v-model="dateTo"
            placeholder="Дата по"
            label="Наявність оплат"
            :filled="false"
            clearable
          />
        </v-col>
      </v-row>
    </template>
  </DataList>
</template>

<script>
import * as invoicesApi from "../../../backend/invoicesApi.js";
import paymentStateTypes from "../../../helpers/paymentStateTypes.js";
import EnumSelect from "@/components/selects/EnumSelect";
import DatePicker from "@/components/story/DatePicker.vue";

export default {
  components: {
    EnumSelect,
    DatePicker,
  },
  data: () => ({
    client: null,
    columns: [
      { title: "id", name: "id" },
      { title: "Дата", name: "date" },
      { title: "Номер", name: "number" },
      { title: "Клієнт", name: "client", dataPath: "client.title", rowType: "wide" },
      {
        title: "Сума",
        name: "totalAmount",
        type: "decimal",
      },
      {
        title: "Оплати",
        name: "totalPaymentsAmount",
        type: "decimal",
      },
      { type: "label" },
    ],
    rolePaymentState: null,
    paymentState: null,
    dateFrom: "",
    dateTo: "",
  }),
  computed: {
    paymentStateTypes(){
      return [
        {
          value: paymentStateTypes.PAID.value,
          text: paymentStateTypes.PAID.title,
        },
        {
          value: paymentStateTypes.PARTIALLY_PAID.value,
          text: paymentStateTypes.PARTIALLY_PAID.title,
        },
        {
          value: paymentStateTypes.UNPAID.value,
          text: paymentStateTypes.UNPAID.title,
        },
      ];
    },
    filter(){
      return {
        invoicePaymentStatus: (this.rolePaymentState || this.rolePaymentState === 0) ? this.rolePaymentState : "",
        dateFrom: this.dateFrom ? this.dateFrom : "",
        dateTo: this.dateTo ? this.dateTo : "",
      };
    },
  },
  watch: {
    client: {
      handler(val) {
        this.filter = val?.title || "";
      },
      deep: true,
    },
    rolePaymentState(val){
      this.paymentState = this.paymentStateTypes.find(
        (el) => el.value === val
      );
    },
  },
  methods: {
    getInvoices(...args) {
      return invoicesApi.getInvoices(args[0], args[1], args[2], args[3]);
    },
  },
};
</script>
